import Vue from 'vue';
import { deepCopy, getCurrentIP, clearAllSignals, findPinBySignal, filterOptions, clearPinSignal } from './utils';
import { CONFIG_NAME_USART, USART_SIGNAL_TX, USART_SIGNAL_RX, USART_SIGNAL_CK } from './constants';
import { configGpio } from './gpio';


export function usartChangeMode(state, mode) {
    const currentIP = getCurrentIP(state);

    if (!currentIP) return;

    currentIP.mode = mode;

    const instanceName = currentIP.instance;

    clearAllSignals(state, currentIP);

    if (mode === 'Disable') {
        return;
    }

    resetConfigFields(state, currentIP, mode);

    switch (mode) {

        case "Synchronous":
            setPinSignal(state, currentIP, USART_SIGNAL_CK);
        case "Asynchronous":
            setPinSignal(state, currentIP, USART_SIGNAL_TX);
            setPinSignal(state, currentIP, USART_SIGNAL_RX);
            break;
        case "Disable":
            // nothing to do
            break;

        default:
            console.log(`@`, `Sorry, mode=${mode} not support!`);
    }
}

export function usartChangeHardwareFlowControl({ state }, flowControl) {

    // console.log(`state`, state)
    // console.log(`flowControl`, flowControl)

    const currentIP = getCurrentIP(state);

    if (!currentIP) return;

    clearPinSignal(state, currentIP, 'RTS');
    clearPinSignal(state, currentIP, 'CTS');

    const instanceName = currentIP.instance;

    switch (flowControl) {

        // TODO: 这里每个引脚的 GPIO 参数还需要加上
        case "UART_HWCONTROL_NONE":
            break;
        case "UART_HWCONTROL_RTS":
            setPinSignal(state, currentIP, 'RTS');
            break;
        case "UART_HWCONTROL_CTS":
            setPinSignal(state, currentIP, 'CTS');
            break;
        case "UART_HWCONTROL_RTS_CTS":
            setPinSignal(state, currentIP, 'RTS');
            setPinSignal(state, currentIP, 'CTS');
                // nothing to do
            break;

        default:
            console.log(`@`, `Sorry, flowControl=${flowControl} not support!`);
    }
}

function setPinSignal(state, currentIP, _signal) {
    const signal = currentIP.instance + '_' + _signal;

    const pin = findPinBySignal(state.chip.pins, signal);

    if (pin) {

        // state.chip.pins 中为引脚修改状态
        Vue.set(pin, 'signal', signal);
        Vue.set(pin, 'ip', currentIP.instance);

        const pinCopy = configPin(state, pin, _signal)
        currentIP.pins.push(pinCopy);
    }
}

function resetConfigFields(state, currentIP, modeName) {

    const config = state.config[currentIP.name];

    // console.log('modes', config);

    const mode = config.modes.find(m => m.name === modeName);
    const fields = [];

    for (const p of mode.parameters) {
        let field = config.parameters.find(_p => _p.name === p.name);
        if (field) {
            field = deepCopy(field);
            if (p.options) {
                field.options = filterOptions(field.options, p.options);
            }

            if (p.value) {
                field.value = p.value;
            } else if (field.default) {
                field.value = field.default
            }

            // console.log(field.value)

            if (p.hasOwnProperty('visible')) {
                field.visible = p.visible
            }

            fields.push(field);
        } else {
            console.error(`usart field not found: ${p.name}`)
        }
    }

    Vue.set(currentIP, 'fields', fields);
}


function configPin(state, _pin, _signal) {

    const usart = state.config[CONFIG_NAME_USART];
    if (usart) {
        const signal = usart.signals.find(s => s.name === _signal);
        if (signal) {
            const pinCopy = configGpio(state, _pin, signal.mode)
            return pinCopy;
        }
    }
}